/**
 * Optional lightweight Web Audio beeps — no external assets.
 */

let ctx;

function ac() {
  if (!ctx) {
    ctx = new (window.AudioContext || window.webkitAudioContext)();
  }
  return ctx;
}

export function resumeAudio() {
  const a = ac();
  if (a.state === 'suspended') {
    a.resume().catch(() => {});
  }
}

export function playBeep(freq = 440, duration = 0.06, type = 'square', gain = 0.04) {
  try {
    const audio = ac();
    const osc = audio.createOscillator();
    const g = audio.createGain();
    osc.type = type;
    osc.frequency.value = freq;
    g.gain.value = gain;
    g.gain.exponentialRampToValueAtTime(0.001, audio.currentTime + duration);
    osc.connect(g);
    g.connect(audio.destination);
    osc.start();
    osc.stop(audio.currentTime + duration);
  } catch {
    /* optional */
  }
}

export function sfxCollect() {
  playBeep(660, 0.05, 'square', 0.03);
}

export function sfxHit() {
  playBeep(120, 0.15, 'sawtooth', 0.06);
}

export function sfxPower() {
  playBeep(880, 0.08, 'triangle', 0.035);
}
